var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPublish(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 395 274",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,\n            .cls-2 {\n                fill: none;\n            }\n\n            .cls-3 {\n                opacity: .1;\n            }\n\n            .cls-3,\n            .cls-4 {\n                fill: #96abc0;\n            }\n\n            .cls-5 {\n                fill: url(#Confettis_5);\n            }\n\n            .cls-6 {\n                clip-path: url(#clippath);\n            }\n\n            .cls-7,\n            .cls-8 {\n                fill: #004753;\n            }\n\n            .cls-9 {\n                fill: #022326;\n            }\n\n            .cls-10 {\n                fill: #041e21;\n            }\n\n            .cls-11 {\n                fill: #054752;\n            }\n\n            .cls-12 {\n                fill: #669198;\n            }\n\n            .cls-13,\n            .cls-14 {\n                fill: #f6b241;\n            }\n\n            .cls-15,\n            .cls-16 {\n                fill: #fce1d8;\n            }\n\n            .cls-17 {\n                fill: #fff;\n            }\n\n            .cls-18,\n            .cls-19 {\n                fill: #eacb92;\n            }\n\n            .cls-20 {\n                fill: #9ea8ad;\n            }\n\n            .cls-21 {\n                fill: #736449;\n            }\n\n            .cls-22,\n            .cls-23,\n            .cls-24 {\n                fill: #af865e;\n            }\n\n            .cls-25 {\n                fill: #bc9068;\n            }\n\n            .cls-26 {\n                fill: #aab8c1;\n            }\n\n            .cls-27 {\n                fill: #cd9f6f;\n            }\n\n            .cls-28 {\n                fill: #162d38;\n            }\n\n            .cls-29 {\n                fill: #9aed66;\n            }\n\n            .cls-30 {\n                fill: #2ed1ff;\n            }\n\n            .cls-31 {\n                fill: #7a5334;\n            }\n\n            .cls-32 {\n                fill: #547b7f;\n            }\n\n            .cls-2 {\n                stroke: #669198;\n                stroke-miterlimit: 10;\n                stroke-width: 1.26px;\n            }\n\n            .cls-16,\n            .cls-14,\n            .cls-33,\n            .cls-23,\n            .cls-24,\n            .cls-19,\n            .cls-8,\n            .cls-34,\n            .cls-35,\n            .cls-36 {\n                mix-blend-mode: multiply;\n            }\n\n            .cls-37 {\n                clip-path: url(#clippath-1);\n            }\n\n            .cls-38 {\n                clip-path: url(#clippath-4);\n            }\n\n            .cls-39 {\n                clip-path: url(#clippath-3);\n            }\n\n            .cls-40 {\n                clip-path: url(#clippath-2);\n            }\n\n            .cls-41 {\n                clip-path: url(#clippath-7);\n            }\n\n            .cls-42 {\n                clip-path: url(#clippath-8);\n            }\n\n            .cls-43 {\n                clip-path: url(#clippath-6);\n            }\n\n            .cls-44 {\n                clip-path: url(#clippath-5);\n            }\n\n            .cls-45 {\n                clip-path: url(#clippath-9);\n            }\n\n            .cls-23 {\n                opacity: .27;\n            }\n\n            .cls-24 {\n                opacity: .4;\n            }\n\n            .cls-19,\n            .cls-36 {\n                opacity: .67;\n            }\n\n            .cls-8 {\n                opacity: .5;\n            }\n\n            .cls-46 {\n                fill: #7d3561;\n            }\n\n            .cls-46,\n            .cls-47,\n            .cls-34 {\n                opacity: .2;\n            }\n\n            .cls-47 {\n                fill: #8f405f;\n            }\n\n            .cls-48 {\n                opacity: .3;\n            }\n\n            .cls-49 {\n                opacity: .23;\n            }\n\n            .cls-50 {\n                isolation: isolate;\n            }\n\n            .cls-35 {\n                opacity: .65;\n            }\n        "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m32.74,32.45v195.7h172.7c2.76-14.43,32.67-35.73,78.23-34.48,45.83,1.27,61.04,24.81,67.16,34.48l11.43-.18V32.45H32.74Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m211.23,232.34c-2.44-12.91,1.34-27.81,1.88-29.53,0,0,75.39,2.51,74.13,23.25-.06,1.03-4.31,19.51-8.17,20.73-10.09,3.19-51.29,2.52-51.3,2.51-7.75-.62-14.87-8.06-16.55-16.96Z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "Confettis_5",
    "data-name": "Confettis 5",
    x: 0,
    y: 0,
    width: 50.86,
    height: 47.05,
    patternTransform: "translate(-2157.44 -1660.13) scale(.82)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 50.86 47.05"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 50.86,
    height: 47.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 50.84,
    y: 46.81,
    width: 50.9,
    height: 47.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: -0.02,
    y: 46.81,
    width: 50.9,
    height: 47.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: -50.88,
    y: 46.81,
    width: 50.9,
    height: 47.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 50.84,
    y: -0.23,
    width: 50.9,
    height: 47.52
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: -0.02,
    y: -0.23,
    width: 50.9,
    height: 47.52
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "12.91 4.84 11.11 4.84 11.09 .19 12.9 .19 12.91 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "20.4 6.97 18.93 8.02 16.24 4.2 17.72 3.16 20.4 6.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "13.66 14.59 13.32 12.82 17.88 11.92 18.23 13.69 13.66 14.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "22.65 13.39 21.27 12.22 24.27 8.66 25.64 9.82 22.65 13.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "26.99 19.85 25.2 19.68 25.6 15.05 27.4 15.21 26.99 19.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "16.94 21.31 17.81 19.74 21.89 22 21 23.58 16.94 21.31"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "4.17 7 2.69 8.03 .01 4.22 1.49 3.19 4.17 7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "6.42 13.41 5.04 12.25 8.04 8.68 9.43 9.85 6.42 13.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "10.76 19.87 8.97 19.71 9.38 15.07 11.18 15.23 10.76 19.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: ".71 21.34 1.58 19.77 5.65 22.02 4.78 23.6 .71 21.34"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "29.74 4.82 27.93 4.82 27.93 .17 29.73 .16 29.74 4.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "37.22 6.95 35.74 7.99 33.07 4.17 34.54 3.14 37.22 6.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "30.49 14.57 30.14 12.8 34.71 11.89 35.06 13.66 30.49 14.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "39.48 13.37 38.1 12.2 41.09 8.64 42.48 9.8 39.48 13.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "43.82 19.82 42.02 19.67 42.43 15.02 44.22 15.18 43.82 19.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "33.76 21.29 34.64 19.71 38.71 21.98 37.83 23.55 33.76 21.29"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "45.51 4.8 43.71 4.8 43.7 .14 45.5 .14 45.51 4.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "46.27 14.54 45.92 12.77 50.49 11.87 50.84 13.65 46.27 14.54"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "12.95 28.43 11.14 28.44 11.13 23.78 12.94 23.78 12.95 28.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "20.43 30.56 18.96 31.6 16.28 27.79 17.75 26.75 20.43 30.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "13.7 38.18 13.35 36.4 17.92 35.5 18.27 37.27 13.7 38.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "22.68 36.97 21.3 35.81 24.31 32.25 25.68 33.41 22.68 36.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "27.03 43.44 25.23 43.27 25.64 38.64 27.44 38.8 27.03 43.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "16.97 44.91 17.84 43.33 21.91 45.59 21.05 47.16 16.97 44.91"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "4.2 30.58 2.73 31.62 .04 27.82 1.53 26.78 4.2 30.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "6.46 37 5.08 35.83 8.08 32.27 9.46 33.44 6.46 37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "10.8 43.46 9 43.3 9.41 38.66 11.21 38.82 10.8 43.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: ".74 44.93 1.62 43.35 5.69 45.62 4.81 47.19 .74 44.93"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "29.77 28.41 27.97 28.41 27.96 23.75 29.77 23.75 29.77 28.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "37.26 30.54 35.79 31.58 33.1 27.77 34.58 26.73 37.26 30.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "30.53 38.15 30.18 36.39 34.75 35.48 35.1 37.25 30.53 38.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "39.51 36.95 38.13 35.79 41.13 32.23 42.51 33.39 39.51 36.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "43.85 43.41 42.06 43.25 42.47 38.61 44.27 38.77 43.85 43.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "33.79 44.88 34.67 43.31 38.74 45.56 37.87 47.14 33.79 44.88"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "45.54 28.39 43.75 28.39 43.74 23.73 45.54 23.73 45.54 28.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "46.31 38.13 45.95 36.36 50.53 35.46 50.87 37.23 46.31 38.13"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: -50.88,
    y: -0.23,
    width: 50.9,
    height: 47.52
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "-4.55 38.13 -4.91 36.36 -.33 35.46 .01 37.23 -4.55 38.13"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 50.84,
    y: -47.28,
    width: 50.9,
    height: 47.52
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: -0.02,
    y: -47.28,
    width: 50.9,
    height: 47.52
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "16.97 -2.13 17.84 -3.72 21.91 -1.46 21.05 .12 16.97 -2.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: ".74 -2.12 1.62 -3.69 5.69 -1.43 4.81 .14 .74 -2.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "33.79 -2.16 34.67 -3.74 38.74 -1.48 37.87 .1 33.79 -2.16"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: -50.88,
    y: -47.28,
    width: 50.9,
    height: 47.52
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m264.05,245.3c.27-2.17.58-4.17-.26-10.76-.07-.68-.19-1.36-.38-2.04-1.78-6.27-8.3-9.92-14.57-8.14-5.69,1.61-8.48,6.54-9.97,16.15s-1.87,26.78,1.08,35.54c4.09,12.14,10.21,49.99,10.23,51.16l9.06-.73s4.29-76.93,4.81-81.18Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 124.09,
    y: 108.4,
    width: 24.03,
    height: 21.53,
    transform: "translate(10.03 248.9) rotate(-87.02)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.22,
    y: 92.38,
    width: 16.77,
    height: 6.9,
    transform: "translate(35.7 229.27) rotate(-87.02)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 122.2,
    y: 94.31,
    width: 2.82,
    height: 1.29,
    transform: "translate(22.36 213.46) rotate(-87.02)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 147.96,
    y: 95.63,
    width: 3.78,
    height: 1.23,
    transform: "translate(45.96 240.9) rotate(-87.02)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 135.94,
    y: 111.42,
    width: 1.16,
    height: 4.16,
    transform: "translate(16.09 243.95) rotate(-87.02)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m35.14,183.96l24.19.4s2.51,13.1,5.04,27.76c2.07,11.98,4.17,25.69,4.73,28.35l28.94-.32h.73s0-.01,0-.01l29.66-1.51c1.2-7.44,2.48-35.86,4.85-56.19l24.82-1.79s3.81-48.25-27.33-45.42c-.18.02-.34.08-.5.19-9.93-3.44-23.39-7.25-23.39-7.25,0,0-5.91-.53-10.58-.39-2.35.04-8.9.88-8.9.88,0,0-.4.11-1.12.3-4.05,1.07-18.1,4.85-27.12,8.08-27.27-.58-24.01,46.93-24.01,46.93Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m32.74-322.32V-126.61h172.7c2.76-14.43,32.67-35.73,78.23-34.48,45.83,1.27,61.04,24.81,67.16,34.48l11.43-.18v-195.52H32.74Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m107.94,126.19c-4.14,0-7.37-3.61-6.9-7.72,1.15-9.96,6.39-26.87,28.05-34.16,33.72-11.34,115.04-26.94,133.85-20.53,15.78,5.38,40.57,36.59,44.76,54.34,1.02,4.34-2.35,8.47-6.81,8.46l-192.96-.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m336.5,146.47c-.62-8.17-8.1-18.14-17.63-19.33-8.26-1.03-217.45-.67-224.74.24-9.54,1.19-18.36,11.16-18.98,19.33-1.77,23.31-2.66,76.85-2.66,86.31l266.66-.24c0-9.46-.88-63.01-2.66-86.31Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "221.28 87.21 216.26 150.67 264 149.41 257.72 82.82 239.86 66.97 221.28 87.21"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m204.75,227.28c.52,2.61,2.06,4.98,4.61,6.18.32.84.75,1.85.85,2.07.35.73,1.17,1.71,1.48,2.64.5,1.41,1.25,2.73,1.65,3.49-1,.48-2.06.15-2.8-1.35-.62-1.11-.99-2.21-1.53-2.05-.31.14-.06,1.09.54,3.17.52,1.68,1.33,4.3,1.84,6.59.38,1.42-1.03,1.67-1.5.78-.8-1.58-1.87-5.54-2.32-6.21-.15-.25-.39-.09-.38.11.28,1.96,3,6.46,1.46,7.02-.22.02-.41-.02-.6-.14-.27-.19-.51-.58-.79-1.21-.05-.17-.13-.33-.19-.49-.69-1.78-1.33-3.56-1.79-4.45-.09-.25-.38-.33-.44-.1-.09.13.34,1.25.77,2.52.63,1.79,1.36,3.96.74,4.2-.63.26-1.08-.66-1.59-1.9-.89-2.11-1.69-5.08-1.84-5.18-.15-.06-.39-.05-.3.18.19.77.7,2.78,1,4.16.14.71-.48,1.13-.82.79-.7-1.27-1.51-3.98-2.22-5.9-1.3-3.56-1.33-7.38-2.49-10.75-.19-.63-.4-1.06-.71-1.8,2.47-.46,4.96-1.3,7.36-2.36Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m211.23,232.34c-2.44-12.91,1.34-27.81,1.88-29.53,0,0,51.69,5.21,54.03,7.54,5.03-.63,23.87-3.77,22.62,16.96-.06,1.03-6.82,18.25-10.68,19.48-10.09,3.19-51.29,2.52-51.3,2.51-7.75-.62-14.87-8.06-16.55-16.96Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m205.83,221.34c6.03,11.63,6.03,17.28,20.48,17.28s5.65-14.45,25.76-14.45c16.35,0,15.71,25.13,15.71,25.13l-57.24.81-4.7-28.77Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m257.65,165.7l-28.92,1.1c-4.26.11-6.79-1.43-9.65-4-.33-.29-2.38,22.44,50.32,13.35.28-.05,2.7-19.84,2.7-19.84,0,0-2.54,9.44-14.45,9.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m258.98,140.62l27.01,36.44c.05.04,10.47-5.74,11.23-6.1.04-.1-2.06-5.13-5.58-12.01-.02,0-.02-.04-.04-.05-5.53-10.79-10.58-22.85-20.07-30.84-.88-.78-9.89,10.39-12.57,12.57Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m226.22,145.58l-24.52,44.95s-13.88-5.02-14.7-5.25c-.06-.1,1.13-5.41,3.4-12.8.01,0,0-.04.03-.05,3.56-11.59,9.71-28.2,17.65-37.73.73-.93,15.12,9.2,18.13,10.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m221.24,131.07c-5.3-2.4-11.55-.05-13.95,5.26-2.4,5.3-.05,11.55,5.26,13.95,5.3,2.4,11.55.05,13.95-5.26,2.4-5.31.05-11.56-5.26-13.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m193.18,179.67c-4.24.81-7.03,4.9-6.23,9.14.8,4.24,4.89,7.02,9.13,6.21,4.25-.81,7.04-4.9,6.23-9.14-.8-4.24-4.89-7.02-9.14-6.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m187.59,195.42c2.74,16.46,6.18,26.12,7.78,29.99.52,1.38.81,1.87,1.07,2.72,1.16,3.36,1.2,7.19,2.49,10.75.71,1.92,1.52,4.63,2.22,5.9.34.34.97-.08.82-.79-.31-1.38-.81-3.39-1-4.16-.08-.23.16-.24.3-.18.14.11.95,3.07,1.84,5.18.51,1.25.96,2.16,1.59,1.9.62-.24-.11-2.41-.74-4.2-.43-1.27-.86-2.39-.77-2.52.06-.23.35-.16.44.1.46.89,1.1,2.68,1.79,4.45.07.17.14.33.19.49.29.64.52,1.03.79,1.21.19.12.37.15.6.14,1.54-.56-1.18-5.07-1.46-7.02-.02-.2.23-.36.38-.11.45.67,1.52,4.63,2.32,6.21.47.89,1.88.64,1.5-.78-.51-2.29-1.33-4.91-1.84-6.59-.6-2.08-.86-3.02-.54-3.17.54-.17.92.94,1.53,2.05.74,1.5,1.79,1.83,2.8,1.35-.41-.76-1.15-2.08-1.65-3.49-.31-.92-1.13-1.91-1.48-2.64-.15-.31-1.01-2.37-1.19-3.03-3.48-12.73-4.03-31.45-3.96-34.45.1-4.46-1.08-8.62-1.08-8.62l-15.47,2.05c.08,1.98.14,3.61.74,7.26Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m203.39,192.58c.08,1.17.03,4.22.12,6.07.12,2.32,1.57,20.72,2.84,27.74-3.29-5.97-10.38-23.82-8.04-38.21.03-.18-.03.16,0,0,.13-.81.07-.55.24-1.35,4.19-19.39,16.95-38.72,16.95-38.72l.78,15.78-13.67,24.35.78,4.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m279.84,132.75c-3.87-5.72-7.35-8.87-8.36-9.27-.01-.02-.03-.04-.04-.05-4.85-2.7-23.78-6.42-23.78-6.42,0,0-5.08-.39-6.89-.33l.04.89c-2.26-.03-8.59-.16-8.59-.16,0,0-18.74,6.88-23.52,9.71,0,0,0,0,0,0,0,0-9.01,10.64-12.86,24.21l18.84,13.62c3.06,16.93-5.32,42.86-5.32,64.23,69.74-32.04,76.65-14.45,76.65-14.45-8.8-18.85-19.48-30.16-13.67-54.87l16.81-9.84s-4.4-10.05-9.29-17.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m279.84,132.75c-3.87-5.72-7.35-8.87-8.36-9.27-.01-.02-.03-.04-.04-.05-4.85-2.7-23.78-6.42-23.78-6.42,0,0-5.08-.39-6.89-.33l.04.89c-2.26-.03-8.59-.16-8.59-.16,0,0-18.74,6.88-23.52,9.71,0,0,0,0,0,0,0,0-9.01,10.64-12.86,24.21l18.84,13.62c3.06,16.93-5.32,42.86-5.32,64.23,69.74-32.04,76.65-14.45,76.65-14.45-8.8-18.85-19.48-30.16-13.67-54.87l16.81-9.84s-4.4-10.05-9.29-17.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m247.12,102.53l-15.75.4.36,11.45c.02.88-4.15,4.87-7.92,6.12-2.46.82,1.88,11.31,15.71,11.31s22.6-11.87,19.48-12.57c-5.65-1.26-11.31-3.14-11.31-3.14l-.55-13.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270.6,121.2l-7.5-2.15s-50.17,94.8-51.68,96.97c-.32.46-1.3,13.74-1.3,13.74l6.35-.96s52.81-103.19,54.12-107.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m227.96,117.87s6.07,76.68,15.94,75.52c10.68-1.26,8.8-76.65,8.8-76.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m231.72,103.87c.34.1,3.33,13.97,15.96,12.39l-.59-13.56-15.38,1.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m291.81,263.3c.21-13.25-2.05-39.13-2.05-39.13l-25.95,1.27s.36,8.74,7.23,42.05c3.93,19.04,8.51,42.2,11.36,50.57l9.94-1.87c-1.65-17.49-.87-31.52-.53-52.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m289.73,224.12c-.37,7.23-6.41,12.76-13.46,12.39-7.06-.38-12.49-6.54-12.12-13.77.38-7.22,6.41-12.77,13.46-12.39,7.06.38,12.48,6.54,12.11,13.76Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 226.31,
    y: 142.5,
    width: 14.88,
    height: 27.59,
    rx: 1.26,
    ry: 1.26
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m264.05,245.3c.58-6.05-.72-9.98-1.3-12.96-1.26-6.4-7.63-9.76-13.9-7.98-5.69,1.61-8.48,6.54-9.97,16.15s-1.87,26.78,1.08,35.54c4.09,12.14,10.21,49.99,10.23,51.16l9.06-.73s4.4-76.92,4.81-81.18Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m242.01,229.2c-.63.63,4.4-5.65,14.45-1.26,8.38,3.67,7.54,27.64,7.54,27.64l10.05-10.05,3.14-24.5-23.25-2.51-13.82,1.88,1.88,8.8Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m295.09,167.51c3.21,2.88,3.49,7.82.61,11.03-2.88,3.21-7.82,3.49-11.03.61-3.22-2.88-3.49-7.81-.61-11.03,2.88-3.22,7.82-3.49,11.04-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m290.11,165.07s-4.14-1.26-8.6-1.23c6.67-.04-14.92,1.12-34.38-4.54-.66-.19-2.7-1.09-3.01-1.24-.72-.36-1.7-1.2-2.61-1.52-1.4-.53-2.71-1.29-3.46-1.72-.49.99-.18,2.05,1.31,2.82,1.1.63,2.2,1.03,2.03,1.56-.15.31-1.09.04-3.16-.6-1.68-.54-4.28-1.41-6.56-1.95-1.42-.41-1.69,1-.81,1.48,1.57.82,5.51,1.97,6.17,2.43.25.15.08.39-.11.37-1.95-.31-6.42-3.11-7-1.58-.02.22,0,.41.13.6.18.27.57.52,1.2.81.16.06.33.14.49.21,1.76.72,3.54,1.39,4.43,1.86.25.1.32.38.09.44-.13.09-1.25-.36-2.51-.81-1.79-.66-3.94-1.42-4.19-.8-.27.62.63,1.09,1.88,1.62,2.1.92,5.04,1.77,5.15,1.92.06.15.04.39-.18.3-.77-.21-2.77-.75-4.14-1.08-.7-.16-1.13.46-.8.81,1.26.73,3.96,1.58,5.87,2.32,3.54,1.36,7.36,1.45,10.71,2.67.84.28,1.33.57,2.7,1.12,3.84,1.67,13.44,5.26,29.86,8.28,3.64.67,5.95,1.09,7.92,1.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m225,88.12c1.76,11.8,6.15,22.86,13.85,23.02,7.06.14,12.08-11.47,13.23-23.35,1.49-15.35-5.23-20.13-13.75-20.13-8.53,0-15.43,6.35-13.32,20.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m252.1,86.04s1.4-1.27,2.17.39c.2.43.23,1.14.08,3.88-.14,2.45-2.31,3.04-3.28,2.06-.03-.03,1.04-6.32,1.04-6.32Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 242.63,
    cy: 88.41,
    r: 1.13
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 230.49,
    cy: 88.41,
    r: 1.13
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m234.46,96.54c2.51,1.88,4.43.02,4.43.02l-2.96-1.27c.05-.25.37-7.93.41-7.87l-1.87,9.12Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m251.7,87.82s.04.09.09.07.07-.07.1-.11c.16-.21.52-.17.7.02s.24.47.3.73c.09.48.19.99.02,1.46-.16.46-.68.84-1.14.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m241.96,100.91c-1.03-.03-6.98,0-6.98,0,.13,1.27,1.91,2.34,3.58,2.39,1.56.05,3.36-1.24,3.4-2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m221.28,90.98s9.2-2.97,14.36-11.01c5.15-8.04,3.83-14.92,3.83-14.92,0,0-9.05-1.56-14.78,5.88-4.8,6.25-3.5,17.6-3.41,20.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m258.35,91.61s-14.32-5.15-19.48-13.19c-5.15-8.04-5.03-13.19-5.03-13.19,0,0,15.23-1.74,20.99,5.71,4.82,6.23,3.6,18.22,3.51,20.68Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m172.87,177.04s2.13-7.72,4.74-12.86c1.76-3.45,7.51-15.16,10.57-31.94.16-.88.3-3.75.3-4.21,0-1.04-.4-2.65-.25-3.89.2-1.93.07-3.88.02-4.99,1.43,0,2.48.98,2.51,3.14.09,1.64-.09,3.14.63,3.24.44.01.68-1.23,1.14-3.99.34-2.25.84-5.76,1.52-8.72.35-1.87,2.13-1.37,2.19-.07.04,2.28-.91,7.5-.76,8.53.03.38.4.31.5.08.76-2.44.11-9.21,2.22-9.01.27.1.47.25.61.5.21.37.27.95.24,1.85-.02.22-.03.46-.04.69-.19,2.46-.45,4.9-.39,6.2-.04.35.25.59.45.36.17-.09.3-1.65.5-3.36.27-2.44.63-5.38,1.49-5.31.88.05.89,1.36.79,3.11-.14,2.96-.86,6.85-.75,7.06.13.16.42.27.45-.03.2-1.01.73-3.63,1.15-5.41.22-.9,1.19-1.04,1.39-.45.11,1.87-.46,5.49-.7,8.12-.48,4.88-2.57,9.35-3.09,13.92-.16,1.13-.1,1.87-.26,3.76-.29,5.4-3.15,17.81-5.84,30.91-.97,4.69-1.92,7.46-3.49,9.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m156.24,155.12c5.34,14.02,16.99,29.7,21.87,32.26,6.58,3.45,8.74,2.34,12.49-2.45s-18.69-36.94-23.11-41.23c-3.81-3.7-12.88,7.17-11.25,11.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m164.71,139.3c-9.74-2.07-16.61,12.85-10.49,22.25,6.98,10.72,10.31,13.98,10.31,13.98l11.36-22.02s-9.24-13.8-11.19-14.21Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m132.82,72.68h0c-.81.1-1.54-.49-1.64-1.29l-.68-5.72c-.09-.81.49-1.54,1.29-1.64.81-.1,1.54.49,1.64,1.29l.68,5.72c.1.81-.49,1.54-1.29,1.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m128.37,74.45h0c-.81-.04-1.44-.74-1.4-1.55l.3-5.75c.04-.81.74-1.44,1.55-1.4s1.44.74,1.4,1.55l-.3,5.75c-.04.81-.74,1.44-1.55,1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m137.68,71.04h0c-.79-.17-1.31-.95-1.14-1.74l1.17-5.64c.17-.79.95-1.31,1.74-1.14.79.17,1.31.95,1.14,1.74l-1.17,5.64c-.16.79-.95,1.31-1.74,1.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m135.13,72.62h0c-.81-.04-1.44-.74-1.4-1.55l.3-5.75c.04-.81.74-1.44,1.55-1.4s1.44.74,1.4,1.55l-.3,5.75c-.04.81-.74,1.44-1.55,1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m143.24,71.7h0c-.77-.27-1.17-1.11-.9-1.88l1.9-5.44c.27-.77,1.11-1.17,1.88-.9s1.17,1.11.9,1.88l-1.9,5.44c-.27.77-1.11,1.17-1.88.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m141.46,71.89h0c-.79-.16-1.31-.95-1.15-1.74l1.15-5.64c.16-.79.95-1.31,1.74-1.15.79.16,1.31.95,1.15,1.74l-1.15,5.64c-.16.79-.95,1.31-1.74,1.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m144.5,73.14h0c-.71-.39-.97-1.29-.57-2l2.79-5.04c.39-.71,1.29-.97,2-.58.71.39.97,1.3.58,2l-2.79,5.04c-.39.71-1.29.97-2,.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m127.57,86.66h0c.1.8-.47,1.55-1.27,1.65l-5.71.74c-.8.1-1.55-.47-1.65-1.27-.1-.8.47-1.55,1.27-1.65l5.71-.74c.8-.1,1.55.47,1.65,1.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m129.38,91.09h0c-.03.81-.72,1.45-1.53,1.41l-5.75-.23c-.81-.03-1.45-.72-1.41-1.53.03-.81.72-1.45,1.53-1.41l5.75.23c.81.03,1.45.72,1.41,1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m128.62,81.7h0c-.16.8-.93,1.32-1.73,1.16l-5.65-1.1c-.8-.16-1.32-.93-1.16-1.73.16-.8.93-1.32,1.73-1.16l5.65,1.1c.8.16,1.32.93,1.16,1.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m127.47,84.35h0c-.03.81-.72,1.45-1.53,1.41l-5.75-.23c-.81-.03-1.45-.72-1.41-1.53.03-.81.72-1.45,1.53-1.41l5.75.23c.81.03,1.45.72,1.41,1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m129.08,75.84h0c-.26.77-1.1,1.19-1.87.93l-5.46-1.84c-.77-.26-1.19-1.1-.93-1.87.26-.77,1.1-1.19,1.87-.93l5.46,1.84c.77.26,1.19,1.1.93,1.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m127.63,79h0c-.38.71-1.28.98-2,.6l-5.07-2.73c-.71-.38-.98-1.28-.6-2s1.28-.98,2-.6l5.07,2.73c.71.38.98,1.28.6,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m132.2,71.85h0c-.49.65-1.42.78-2.07.29l-4.59-3.47c-.65-.49-.78-1.42-.29-2.07.49-.65,1.42-.78,2.07-.29l4.59,3.47c.65.49.78,1.42.29,2.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m130.01,73.72h0c-.38.71-1.28.98-2,.6l-5.07-2.73c-.71-.38-.98-1.28-.6-2,.38-.71,1.28-.98,2-.6l5.07,2.73c.71.38.98,1.28.6,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m148.1,87.73h0c-.19.79.3,1.59,1.09,1.78l5.6,1.33c.79.19,1.59-.3,1.78-1.09.19-.79-.3-1.59-1.09-1.78l-5.6-1.33c-.79-.19-1.59.3-1.78,1.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m145.83,91.94h0c-.05.81.57,1.51,1.38,1.57l5.75.37c.81.05,1.51-.57,1.57-1.38.05-.81-.57-1.51-1.38-1.57l-5.75-.37c-.81-.05-1.51.57-1.57,1.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m147.56,82.69h0c.07.81.79,1.41,1.6,1.34l5.74-.51c.81-.07,1.41-.79,1.34-1.6-.07-.81-.79-1.41-1.6-1.34l-5.74.51c-.81.07-1.41.79-1.34,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m148.43,85.44h0c-.05.81.57,1.51,1.38,1.57l5.75.37c.81.05,1.51-.57,1.57-1.38.05-.81-.57-1.51-1.38-1.57l-5.75-.37c-.81-.05-1.51.57-1.57,1.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m147.72,76.81h0c.18.79.97,1.29,1.76,1.12l5.62-1.26c.79-.18,1.29-.97,1.12-1.76-.18-.79-.97-1.29-1.76-1.12l-5.62,1.26c-.79.18-1.29.97-1.12,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m148.83,80.1h0c.31.75,1.17,1.11,1.92.8l5.33-2.19c.75-.31,1.11-1.17.8-1.92s-1.17-1.11-1.92-.8l-5.33,2.19c-.75.31-1.11,1.17-.8,1.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m145.03,72.51h0c.42.69,1.33.92,2.02.5l4.93-2.98c.69-.42.92-1.33.5-2.02-.42-.69-1.33-.92-2.02-.5l-4.93,2.98c-.69.42-.92,1.33-.5,2.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m147.01,74.6h0c.31.75,1.17,1.11,1.92.8l5.33-2.19c.75-.31,1.11-1.17.8-1.92-.31-.75-1.17-1.11-1.92-.8l-5.33,2.19c-.75.31-1.11,1.17-.8,1.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "146.68 105.13 125.89 104.8 124.48 142.76 146.45 147.39 146.68 105.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m128.62,125.95l-16.42,7.08s-.16,18.31,22.27,19.47c22.43,1.17,25.01-15.56,25.01-15.56l-14.61-10.56-16.25-.43Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m125.9,108.03c.49.19-.5,22.69,20.33,23.69l.32-24.04-20.65.35Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m135.39,118.45h0c-6.95-.36-12.26-7.85-11.9-14.8l1.21-23.2c.31-5.91,5.39-10.49,11.29-10.18l3.79.2c5.9.31,10.48,5.39,10.18,11.29l-1.21,23.2c-.36,6.95-6.42,13.84-13.37,13.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m130.05,84.68c1.14-1.3,3.19-1.43,4.69.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m142.05,85.59c1.59-1.7,3.76-1.18,4.9.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m125.07,92.54s-1.75-2.47-2.82-.89c-.28.41-.26,2.31-.18,4.9.05,1.7.8,2.98,1.97,2.13.03-.02,1.03-6.14,1.03-6.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m148.23,93.84s1.89-2.37,2.86-.73c.25.42.13,2.32-.09,4.9-.14,1.7-.97,2.93-2.08,2.02-.03-.03-.69-6.19-.69-6.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m129.06,90.69c.76-1.15,6.03.31,7,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m140.74,94.15c1.38-3.33,5.25-4.78,6.22-3.42"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m141.89,99c-.48,9.31-7.09,3.38-7.09,3.38l3.36.28c-.04-.26.64-15.27.61-15.21,0,0,3.63,1.64,3.12,11.55"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m141.38,105.82c-.08.2-1.51,3.23-4.54,2.85-4.64-.58-4.68-3.61-4.68-3.61l9.22.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m123.56,91.5s2.41,2.25,2.93-.78c.33-1.93,1.29-7.43,1.94-11.17.39-2.25,2.29-3.92,4.57-4.04,3.97-.21,10.97-.1,12.61,2.07,3.04,4.04-.88,15.49,4.13,15.04,2.51-.23.43-12.84.07-17.82-.26-3.58-6.68-7.18-15.78-6.54-7.29.51-9.97,7.04-9.97,7.04l-.49,16.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m124.05,93.69c-.22-.25-.65-.14-.85.13s-.22.61-.23.94c-.02.41-.03.84.18,1.19.2.35.71.56,1.03.32"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m149.47,94.33c.47.22.79.69.92,1.19.13.5.09,1.03-.03,1.54-.07.3-.17.61-.38.82-.22.22-.58.32-.84.15"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m134.42,113.98c.48-.66,1.28-1.06,2.09-1.05.81,0,1.61.42,2.07,1.09"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m165.46,139.55s-13.76-8.23-13.76-8.23c0,0,2.57,5.14-15.24,4.21-17.81-.93-16.36-6.28-16.36-6.28,0,0-12.08,3.34-17.6,6.05-.02,0-.03.02-.05.05-1.14.38-6.62,15.12-8.26,34.7-2.22,26.59-1.15,71.51-1.15,71.51l79.03,6.52s-2.31-92.73-6.61-108.54Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m109.65,131.33l7.6-1.76s45.18,97.27,46.57,99.52c.29.48.2,1.03.2,1.03l-5.67,6.76s-47.63-101.08-48.7-105.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m112.52,189.54s3.74,5.14,5.65,9.3c1.28,2.8,5.71,12.16,14.63,22.36.46.53,2.18,2.04,2.47,2.27.65.51,1.85,1.06,2.54,1.77,1.1,1.08,2.38,1.96,3.09,2.48-.71.89-1.83,1.06-3.19.01-1.07-.75-1.91-1.6-2.33-1.21-.23.27.43,1.03,1.92,2.68,1.23,1.32,3.17,3.37,4.66,5.26.99,1.14-.2,2-1.04,1.39-1.44-1.1-4.22-4.27-4.93-4.69-.25-.17-.4.1-.3.27,1.14,1.68,5.67,4.62,4.5,5.83-.2.12-.39.16-.61.13-.33-.05-.73-.3-1.27-.76-.13-.12-.27-.24-.4-.37-1.44-1.33-2.82-2.7-3.66-3.31-.2-.2-.49-.14-.45.11-.03.15.87,1,1.84,1.98,1.38,1.38,3.03,3.05,2.56,3.55-.46.52-1.29-.12-2.32-1.05-1.77-1.55-3.83-3.92-4.02-3.96-.16,0-.38.13-.2.3.53.62,1.89,2.25,2.8,3.39.45.58.06,1.25-.41,1.09-1.22-.86-3.18-3-4.7-4.45-2.8-2.71-4.54-6.22-7.13-8.81-.62-.66-1.11-.99-2.21-2.02-3.21-2.85-9.52-10.76-16.33-18.91-2.44-2.92-3.69-4.88-4.47-7.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m91.1,157.07c-.78,14.98,3.53,34.04,6.96,38.35,4.63,5.81,7.05,5.68,12.42,2.8,5.37-2.87-2.16-41.34-4.47-47.05-1.99-4.92-14.67,1.35-14.91,5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m99.89,136.23c-7.27,4.01-8.57,11.32-9.6,22.49-1.18,12.74-.59,17.36-.59,17.36l27.73-3.57s-1.09-45.36-17.54-36.29Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m54.18,160.66l9.17,28.99-3.21,27.06c-.03.07-17.82,5.08-18.9,5.2-.12-.09-2.5-11.46-3.32-21.42.01-.02,0-.05,0-.08-1.3-15.62-1.6-17.05,3.35-32.3.44-1.46,8.49-8.02,12.91-7.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m40.96,227.34c3.52,21.15,7.94,33.57,10,38.53.67,1.77,1.04,2.4,1.38,3.49,1.49,4.32,1.54,9.24,3.2,13.81.91,2.46,1.95,5.95,2.86,7.58.44.44,1.24-.1,1.06-1.01-.39-1.77-1.05-4.36-1.29-5.34-.11-.29.2-.31.39-.23.19.14,1.22,3.94,2.36,6.66.66,1.6,1.24,2.78,2.04,2.45.8-.31-.14-3.1-.95-5.4-.55-1.63-1.1-3.08-.99-3.24.08-.29.45-.2.56.12.6,1.15,1.41,3.44,2.3,5.72.09.21.18.42.25.63.37.82.67,1.32,1.02,1.56.24.15.48.2.77.17,1.98-.72-1.52-6.51-1.88-9.03-.02-.25.29-.47.48-.14.57.86,1.96,5.95,2.98,7.97.61,1.14,2.42.82,1.93-1.01-.66-2.95-1.7-6.31-2.37-8.47-.77-2.67-1.1-3.88-.7-4.07.69-.22,1.18,1.2,1.97,2.63.95,1.92,2.31,2.35,3.6,1.74-.52-.98-1.48-2.68-2.13-4.48-.39-1.19-1.45-2.46-1.9-3.39-.19-.4-1.3-3.04-1.53-3.9-4.47-16.36-5.18-40.41-5.09-44.27.13-5.73-1.39-11.07-1.39-11.07l-19.88,2.63c.1,2.54.17,4.63.95,9.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m122.83,97.48c-1.35,6.32-4.32,12.27-10.09,15.17,5.41,2.34,6.97,9.61,5.33,15.27-2.52,8.66-10.58,14.94-19.31,17.24s-18.01,1.15-26.74-1.11c-6.77-1.76-13.52-4.27-18.82-8.83-3.97-3.41-6.97-7.86-9.05-12.66-1.41-3.27-2.43-6.8-2.14-10.35.51-6.35,5.34-11.91,11.32-14.13s12.81-1.37,18.54,1.42c-4.59-.83-10.26-2.53-11.73-6.96s-.05-10.44,4.56-12.67c3.7-1.78,10.63-.37,14.48,2.05-13.94-3.56-8.61-21.27,4.16-18.01,8.99,2.29,13.23,2.93,21.36,5,17.75,4.53,19.31,23.12,18.14,28.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m76.85,112.14c.19.74.45,1.51.29,2.26-.22,1.01-1.14,1.7-1.98,2.31-3.7,2.71-7.09,5.84-10.07,9.32-2.56,2.99-4.94,6.63-4.55,10.55.39,3.83,3.49,7.02,7.11,8.33s7.65,1,11.38.06c3.29-.83,6.54-2.2,8.99-4.56,2.46-2.38,3.94-5.59,5.09-8.82,2.76-7.75,3.93-16.06,3.41-24.26-.34-5.41-3.54-17.73-11.44-13.75-5.54,2.79-9.75,12.78-8.24,18.56Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m35.14,183.96l24.19.4s2.51,13.1,5.04,27.76c2.07,11.98,4.17,25.69,4.73,28.35l28.94-.32h.73s0-.01,0-.01l29.66-1.51c1.2-7.44,2.48-35.86,4.85-56.19l24.82-1.79s3.81-48.25-27.33-45.42c-.18.02-.34.08-.5.19-9.93-3.44-23.39-7.25-23.39-7.25,0,0-5.91-.53-10.58-.39-2.35.04-8.9.88-8.9.88,0,0-.4.11-1.12.3-4.05,1.07-18.1,4.85-27.12,8.08-27.27-.58-24.01,46.93-24.01,46.93Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m150.65,130.81c0,1.69,1.37,3.06,3.07,3.06h0c1.69,0,3.07-1.37,3.07-3.06v-4.09c0-1.69-1.37-3.06-3.07-3.06h0c-1.69,0-3.07,1.37-3.07,3.06v4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m114.8,153.73c0,1.36,1.37,2.47,3.06,2.47h0c1.69,0,3.06-1.11,3.06-2.47v-3.29c0-1.36-1.37-2.47-3.06-2.47h0c-1.69,0-3.06,1.11-3.06,2.47v3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m103.16,134.54c0,1.36,1.37,2.47,3.07,2.47h0c1.69,0,3.06-1.11,3.06-2.47v-3.29c0-1.36-1.37-2.47-3.06-2.47h0c-1.7,0-3.07,1.11-3.07,2.47v3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m136.32,149.77c0,1.36,1.37,2.47,3.06,2.47h0c1.7,0,3.07-1.11,3.07-2.47v-3.29c0-1.36-1.37-2.47-3.07-2.47h0c-1.69,0-3.06,1.11-3.06,2.47v3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m127.52,139.91c0,2.14,1.37,3.88,3.07,3.88h0c1.69,0,3.07-1.74,3.07-3.88v-5.18c0-2.14-1.37-3.88-3.07-3.88h0c-1.69,0-3.07,1.74-3.07,3.88v5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m150.65,159.38c0,1.69,1.37,3.06,3.07,3.06h0c1.69,0,3.07-1.37,3.07-3.06v-4.09c0-1.69-1.37-3.06-3.07-3.06h0c-1.69,0-3.07,1.37-3.07,3.06v4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m113.88,178.61c0,1.36,1.37,2.47,3.07,2.47h0c1.69,0,3.06-1.11,3.06-2.47v-3.29c0-1.36-1.37-2.47-3.06-2.47h0c-1.7,0-3.07,1.11-3.07,2.47v3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m97.53,156.11c0,1.36,1.37,2.47,3.06,2.47h0c1.7,0,3.07-1.11,3.07-2.47v-3.29c0-1.36-1.37-2.47-3.07-2.47h0c-1.69,0-3.06,1.11-3.06,2.47v3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m136.32,178.34c0,1.36,1.37,2.47,3.06,2.47h0c1.7,0,3.07-1.11,3.07-2.47v-3.29c0-1.36-1.37-2.47-3.07-2.47h0c-1.69,0-3.06,1.11-3.06,2.47v3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m127.52,168.49c0,2.14,1.37,3.88,3.07,3.88h0c1.69,0,3.07-1.74,3.07-3.88v-5.18c0-2.14-1.37-3.88-3.07-3.88h0c-1.69,0-3.07,1.74-3.07,3.88v5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m100.21,176.11c0,2.14,1.37,3.88,3.06,3.88h0c1.7,0,3.07-1.74,3.07-3.88v-5.18c0-2.14-1.37-3.88-3.07-3.88h0c-1.69,0-3.06,1.74-3.06,3.88v5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m83.06,139.44c0,1.69,1.37,3.06,3.06,3.06h0c1.69,0,3.06-1.37,3.06-3.06v-4.09c0-1.69-1.37-3.06-3.06-3.06h0c-1.69,0-3.06,1.37-3.06,3.06v4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m71.47,142.34c0,1.69,1.37,3.06,3.06,3.06h0c1.69,0,3.06-1.37,3.06-3.06v-4.09c0-1.69-1.37-3.06-3.06-3.06h0c-1.69,0-3.06,1.37-3.06,3.06v4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m45.38,153.94c0,1.69,1.37,3.06,3.06,3.06h0c1.69,0,3.06-1.37,3.06-3.06v-4.09c0-1.69-1.37-3.06-3.06-3.06h0c-1.69,0-3.06,1.37-3.06,3.06v4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m83.06,168.45c0,1.69,1.37,3.06,3.06,3.06h0c1.69,0,3.06-1.37,3.06-3.06v-4.09c0-1.69-1.37-3.06-3.06-3.06h0c-1.69,0-3.06,1.37-3.06,3.06v4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m46.29,178.61c0,1.36,1.37,2.47,3.06,2.47h0c1.7,0,3.07-1.11,3.07-2.47v-3.29c0-1.36-1.37-2.47-3.07-2.47h0c-1.69,0-3.06,1.11-3.06,2.47v3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m68.73,178.34c0,1.36,1.37,2.47,3.07,2.47h0c1.69,0,3.06-1.11,3.06-2.47v-3.29c0-1.36-1.37-2.47-3.06-2.47h0c-1.7,0-3.07,1.11-3.07,2.47v3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m59.93,168.49c0,2.14,1.37,3.88,3.06,3.88h0c1.69,0,3.06-1.74,3.06-3.88v-5.18c0-2.14-1.37-3.88-3.06-3.88h0c-1.69,0-3.06,1.74-3.06,3.88v5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m32.62,176.11c0,2.14,1.37,3.88,3.07,3.88h0c1.69,0,3.06-1.74,3.06-3.88v-5.18c0-2.14-1.37-3.88-3.06-3.88h0c-1.7,0-3.07,1.74-3.07,3.88v5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m150.65,186.58c0,1.69,1.37,3.06,3.07,3.06h0c1.69,0,3.07-1.37,3.07-3.06v-4.09c0-1.69-1.37-3.06-3.07-3.06h0c-1.69,0-3.07,1.37-3.07,3.06v4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m114.8,209.49c0,1.36,1.37,2.47,3.06,2.47h0c1.69,0,3.06-1.11,3.06-2.47v-3.29c0-1.36-1.37-2.47-3.06-2.47h0c-1.69,0-3.06,1.11-3.06,2.47v3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m103.16,193.93c0,1.36,1.37,2.47,3.07,2.47h0c1.69,0,3.06-1.11,3.06-2.47v-3.29c0-1.36-1.37-2.47-3.06-2.47h0c-1.7,0-3.07,1.11-3.07,2.47v3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m136.32,205.53c0,1.36,1.37,2.47,3.06,2.47h0c1.7,0,3.07-1.11,3.07-2.47v-3.29c0-1.36-1.37-2.47-3.07-2.47h0c-1.69,0-3.06,1.11-3.06,2.47v3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m127.52,195.68c0,2.14,1.37,3.88,3.07,3.88h0c1.69,0,3.07-1.74,3.07-3.88v-5.18c0-2.14-1.37-3.88-3.07-3.88h0c-1.69,0-3.07,1.74-3.07,3.88v5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m150.65,215.15c0,1.69,1.37,3.06,3.07,3.06h0c1.69,0,3.07-1.37,3.07-3.06v-4.09c0-1.69-1.37-3.06-3.07-3.06h0c-1.69,0-3.07,1.37-3.07,3.06v4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m113.88,234.38c0,1.36,1.37,2.47,3.07,2.47h0c1.69,0,3.06-1.11,3.06-2.47v-3.29c0-1.36-1.37-2.47-3.06-2.47h0c-1.7,0-3.07,1.11-3.07,2.47v3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m97.53,211.88c0,1.36,1.37,2.47,3.06,2.47h0c1.7,0,3.07-1.11,3.07-2.47v-3.29c0-1.36-1.37-2.47-3.07-2.47h0c-1.69,0-3.06,1.11-3.06,2.47v3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m136.32,234.11c0,1.36,1.37,2.47,3.06,2.47h0c1.7,0,3.07-1.11,3.07-2.47v-3.29c0-1.36-1.37-2.47-3.07-2.47h0c-1.69,0-3.06,1.11-3.06,2.47v3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m127.52,224.25c0,2.14,1.37,3.88,3.07,3.88h0c1.69,0,3.07-1.74,3.07-3.88v-5.18c0-2.14-1.37-3.88-3.07-3.88h0c-1.69,0-3.07,1.74-3.07,3.88v5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m100.21,231.87c0,2.14,1.37,3.88,3.06,3.88h0c1.7,0,3.07-1.74,3.07-3.88v-5.18c0-2.14-1.37-3.88-3.07-3.88h0c-1.69,0-3.06,1.74-3.06,3.88v5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m83.06,197.46c0,1.69,1.37,3.06,3.06,3.06h0c1.69,0,3.06-1.37,3.06-3.06v-4.09c0-1.69-1.37-3.06-3.06-3.06h0c-1.69,0-3.06,1.37-3.06,3.06v4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m47.21,209.49c0,1.36,1.37,2.47,3.07,2.47h0c1.69,0,3.07-1.11,3.07-2.47v-3.29c0-1.36-1.37-2.47-3.07-2.47h0c-1.69,0-3.07,1.11-3.07,2.47v3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m35.57,190.3c0,1.36,1.37,2.47,3.06,2.47h0c1.7,0,3.07-1.11,3.07-2.47v-3.29c0-1.36-1.37-2.47-3.07-2.47h0c-1.69,0-3.06,1.11-3.06,2.47v3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m68.73,205.53c0,1.36,1.37,2.47,3.07,2.47h0c1.69,0,3.06-1.11,3.06-2.47v-3.29c0-1.36-1.37-2.47-3.06-2.47h0c-1.7,0-3.07,1.11-3.07,2.47v3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m59.93,195.68c0,2.14,1.37,3.88,3.06,3.88h0c1.69,0,3.06-1.74,3.06-3.88v-5.18c0-2.14-1.37-3.88-3.06-3.88h0c-1.69,0-3.06,1.74-3.06,3.88v5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m83.06,226.47c0,1.69,1.37,3.06,3.06,3.06h0c1.69,0,3.06-1.37,3.06-3.06v-4.09c0-1.69-1.37-3.06-3.06-3.06h0c-1.69,0-3.06,1.37-3.06,3.06v4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m46.29,234.38c0,1.36,1.37,2.47,3.06,2.47h0c1.7,0,3.07-1.11,3.07-2.47v-3.29c0-1.36-1.37-2.47-3.07-2.47h0c-1.69,0-3.06,1.11-3.06,2.47v3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m29.94,211.88c0,1.36,1.37,2.47,3.07,2.47h0c1.69,0,3.06-1.11,3.06-2.47v-3.29c0-1.36-1.37-2.47-3.06-2.47h0c-1.7,0-3.07,1.11-3.07,2.47v3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m68.73,234.11c0,1.36,1.37,2.47,3.07,2.47h0c1.69,0,3.06-1.11,3.06-2.47v-3.29c0-1.36-1.37-2.47-3.06-2.47h0c-1.7,0-3.07,1.11-3.07,2.47v3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m59.93,224.25c0,2.14,1.37,3.88,3.06,3.88h0c1.69,0,3.06-1.74,3.06-3.88v-5.18c0-2.14-1.37-3.88-3.06-3.88h0c-1.69,0-3.06,1.74-3.06,3.88v5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m32.62,231.87c0,2.14,1.37,3.88,3.07,3.88h0c1.69,0,3.06-1.74,3.06-3.88v-5.18c0-2.14-1.37-3.88-3.06-3.88h0c-1.7,0-3.07,1.74-3.07,3.88v5.18Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m103.14,136.28s.65,19.75-.25,23.16c-.91,3.41-2.02,4.14-4.33,4.14s-2.99-2.34-3.58-4.31c-.6-1.97-3.2-22.37-3.2-22.37,0,0,1.76,1.41,4.78,1.4,3.56,0,6.59-2.02,6.59-2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.23,136.6l10.56-3.5s52.69,100.76,54.28,103.05c.34.48.51.32.51.32l-8.25,8.66s-55.72-103.89-57.1-108.54Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "89.17 108.39 104.79 111.47 107.22 137.5 84.42 139.42 89.17 108.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m105.36,117.07c-.56.12-.46,6.14-18.4,6.12l2.04-13.18,16.36,7.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m85.07,97.66c.18,13.34,3.37,26.25,11.87,27.58,7.8,1.22,15.1-10.89,18.17-23.87,3.96-16.78-2.76-23.08-12.21-24.36-9.44-1.28-18.05,4.71-17.84,20.66Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m101.5,106.41c-.02-.28-.13-9.69-.18-9.62,0,0,4.43.8,3.94,6.28-.71,7.96-8.29,3.22-8.29,3.22"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m114.74,91.72c-1.01-1.69-6.83-3.09-8.64-1.03"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m100.09,90.82c-2.06-2.56-7.5-3-8.96-1.12"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m96.01,97.44c.06,0,.12,0,.18,0,.44-.07.73-.48.66-.92-.15-.94-.92-2.74-2.72-2.86-.03,0-.05,0-.08,0-1.91-.07-2.64,1.34-2.75,2.09-.07.44.23.85.67.91.42.07.84-.23.91-.66.05-.24.25-.79,1.11-.75.01,0,.02,0,.03,0,1.01.07,1.25,1.5,1.26,1.52.06.37.37.65.74.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.91,100.42s.09,0,.14,0c.44-.05.76-.44.71-.87-.1-.97-.77-2.82-2.6-2.94-.03,0-.05,0-.08,0-1.87-.07-2.69,1.32-2.87,2.07-.1.43.17.86.6.96.43.1.85-.16.96-.59.06-.21.31-.88,1.25-.84h.03c.95.07,1.12,1.45,1.13,1.51.04.39.36.69.74.71Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m113.33,107.92c.82.32,1.89-.45,2.37-1.71l1.2-3.12c.48-1.25.21-2.54-.61-2.86h0c-.82-.32-1.89.45-2.37,1.71l-1.2,3.12c-.48,1.25-.21,2.54.61,2.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m84.75,102.49c.87,0,1.58-1.1,1.58-2.44v-3.34c0-1.34-.71-2.44-1.58-2.44h0c-.87,0-1.58,1.1-1.58,2.44v3.34c0,1.34.71,2.44,1.58,2.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m118.18,93.56c-.92.1-34.4-2.85-34.4-2.85,0,0,4.67-15.96,17.64-16.02,27.07-.12,16.76,18.87,16.76,18.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m104.44,113.75c-.16.23-2.91,3.69-6.68,2.29-5.77-2.14-4.92-6.03-4.92-6.03l11.6,3.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m117.49,131.3l-10.62-3.13-20.9.71-11.89,3.52s8.72,17.54,22.5,17.54c13.84,0,20.92-18.06,20.91-18.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m55.08,163.62l7.17,36.02-2,16.12,1.06,20.78s-5.66-8.74-11.19-26.49c-6.25-20.02,4.95-46.43,4.95-46.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m131.18,182.49l-1.31,36.82c.03.08,18.1,3.98,19.17,4.18.13-.09,2.7-8.82,4.3-18.71-.02-.02,0-.05-.01-.08,2.51-15.53,2.42-19,2.13-23.81-.02-.23-19.83,1.38-24.28,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m148.26,229.45c-4.55,20.95-9.58,33.14-11.89,37.99-.75,1.73-1.16,2.35-1.55,3.42-1.71,4.24-1.99,9.15-3.88,13.63-1.03,2.42-2.24,5.85-3.23,7.43-.46.41-1.24-.16-1.01-1.06.48-1.75,1.26-4.3,1.55-5.27.12-.28-.19-.32-.38-.25-.19.13-1.41,3.88-2.69,6.54-.74,1.57-1.37,2.72-2.16,2.34-.78-.35.29-3.09,1.21-5.35.63-1.6,1.25-3.02,1.15-3.19-.06-.3-.44-.22-.57.1-.65,1.12-1.58,3.36-2.58,5.6-.1.21-.2.41-.28.62-.41.8-.74,1.28-1.1,1.51-.25.14-.49.17-.77.14-1.94-.82,1.84-6.43,2.32-8.92.03-.25-.27-.48-.48-.16-.61.83-2.25,5.84-3.37,7.82-.66,1.11-2.46.7-1.88-1.1.8-2.91,2.01-6.21,2.78-8.34.9-2.63,1.29-3.83.9-4.03-.68-.25-1.23,1.14-2.1,2.53-1.04,1.88-2.42,2.23-3.68,1.56.57-.95,1.61-2.6,2.34-4.37.45-1.17,1.57-2.38,2.06-3.29.21-.39,1.45-2.98,1.72-3.82,5.27-16.12,7.17-40.11,7.27-43.96.15-5.73,1.93-10.99,1.93-10.99l19.73,3.61c-.22,2.53-.4,4.62-1.41,9.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m137.79,163.87l-6.61,18.92-3.19,49.32s9.61-5.74,15.13-23.49c6.25-20.02-5.33-44.75-5.33-44.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "DRVR"
  }, /*#__PURE__*/React.createElement("g", {
    id: "body"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m323.75,158.81l7.4,72.21c.03.07,20.46,5.43,21.65,5.58.13-.09,1.92-12.09,3-22.98-.02-.02,0-.05,0-.09,1.7-17.1,2.11-40.29-3.06-57.09-.45-1.62-24.13,1.82-28.99,2.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m323.75,158.81l7.4,72.21c.03.07,20.46,5.43,21.65,5.58.13-.09,1.92-12.09,3-22.98-.02-.02,0-.05,0-.09,1.7-17.1,2.11-40.29-3.06-57.09-.45-1.62-24.13,1.82-28.99,2.36"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m249.34,156.05l-16.43,70.7c-.04.07-20.98,2.81-22.18,2.81-.12-.11-.38-12.23-.09-23.18.02-.02,0-.05.02-.08.47-17.18,2.98-40.23,10.22-56.25.65-1.55,23.71,4.84,28.46,5.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m242.32,185.16l-9.36,43c-.04.07-19.29,3.87-19.29,3.87l28.65-46.88Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m210.72,180.63s3.67-15.54,7.21-25.31c6.38-17.58,19.33-27.52,28.09-27.12,0,0,.24.26.24.26,8.97-4.36,32.16-7.74,32.16-7.74,0,0,5.3.97,9.65,1.6,5.14.2,11.16-.73,11.16-.73,0,0,23.52,3.81,37.23,12.33,3.59,1.5,14.04,9.43,18.7,17.04,6.87,11.23,4.87,38.78,4.87,38.78l-30.94-.44c-4.31,24.74-7.26,61.72-8.69,67.75l-35.03-1.5h0s-43.09-1.95-43.09-1.95c-.88-6.16.45-43.69-1.27-68.76l-30.28-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m332.43,166.82l-8.55,20.33-4.58,52.62s9.81-4.64,17.06-23.75c8.19-21.55-3.92-49.2-3.92-49.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m238.62,162.55l6.67,21.02-.22,52.82s-9.35-5.52-14.83-25.2c-6.2-22.21,8.37-48.64,8.37-48.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m328.35,188.63l-8.22,66.44-11.07,21.07s-30.99,14.48-31.94-7.93c-1.45-34.42,51.23-79.59,51.23-79.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.6,126.78s-64.68,78.84-78.81,121.21l14.54.23s54.98-85.62,80.56-115.23c0,0-9.55-3.99-16.3-6.22Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Head"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 282.96,
    y: 57.44,
    width: 21.06,
    height: 43.33,
    rx: 9.22,
    ry: 9.22,
    transform: "translate(592.42 134.13) rotate(175.34)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 257.77,
    y: 59.49,
    width: 21.06,
    height: 43.33,
    rx: 8.29,
    ry: 8.29,
    transform: "translate(542.3 140.27) rotate(175.34)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 262.64,
    y: 47.37,
    width: 21.06,
    height: 43.33,
    rx: 8.29,
    ry: 8.29,
    transform: "translate(551.03 115.66) rotate(175.34)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 274.63,
    y: 42.94,
    width: 21.06,
    height: 43.33,
    rx: 9.22,
    ry: 9.22,
    transform: "translate(574.61 105.85) rotate(175.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m267.94,122.43s.14,1.57.85,3.62c1.25,3.55,4.25,8.55,11.29,9.13.42,0,.77.06,1.15-.02t.1-.02c.05.03.08,0,.08,0h.03c12.87.6,16.62-6.16,17.47-11.62,2.06-13.38-2.36-34.95-2.36-34.95l-28.62,10.37v16.94s.02,6.54.02,6.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m290.22,111.59c-.38.13-7.8,13.93-22.03,12.41,0,0-.37-10.29-.21-13.87.13-2.94,1.21-12.15,1.21-12.15l21.03,13.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m299.18,95.72s1.31-19.29-5.67-28.98c-10.07-13.97-28.29-6.55-31.54,1.64-4.44,11.19,1.09,33.78,1.09,33.78l36.12-6.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m260.59,83.52l1.13,8.02c1.28,13.99,3.58,25.4,15.12,26.17,1.66.11,3.44-.02,4.53-.17l-2.98-41.87-2.69.2-3.42.3-4.28.31c-3.02.29-5.82,1.92-6.72,4.48-.33.72-.64,1.55-.63,2.37l-.05.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m298.2,81.33v8.1c.23,7.83-1.35,25.74-12.66,28.13-1.65.35-2.83.45-3.95.44l-3.43-41.83,4-.27,3.43-.19,4.26-.29c3.06-.16,6.04,1.07,7.3,3.46.42.7.86,1.46.96,2.28l.08.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m270.69,102.22c2.51-.24,16.97-1.07,16.97-1.07-.11,3.1-4.29,5.97-8.34,6.35-3.8.36-8.35-2.5-8.63-5.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m274.6,86.46s.38,10.68.49,10.85c.58.82,4.47.71,4.47.71,0,0-4.79,4.15-9.06,1.57-4.3-2.58-6.9-14.25,4.1-13.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m294.12,108s-22.55,1.29-28.44,1.66c-.14,0,4.54,11.68,12.99,10.9,10.11-.93,15.45-12.57,15.45-12.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m271.94,66.17c.04,2.7-.36,5.61-2.3,7.62-1.94,2.01-5.83,2.49-7.55.34-.86-1.07-1-2.49-1.05-3.83-.19-4.68.59-9.86,4.29-13.03,6.2-5.32,19.45-7.83,22.99,1.29,4.16,10.69-16.33,10.75-16.38,7.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 297.22,
    y: 88.18,
    width: 4.44,
    height: 7.48,
    rx: 2.22,
    ry: 2.22,
    transform: "translate(603.6 166.71) rotate(176.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m298.13,90.78c.94.14,1.86.83,1.99,1.77s-.82,1.95-1.73,1.65"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m283.67,88.88c.55.03,1.05-.37,1.14-.93,0-.01.32-1.77,1.51-1.81,1.1-.04,1.26.69,1.28.83.09.61.66,1.02,1.27.93.6-.09,1.02-.66.93-1.27-.15-.98-1.08-2.8-3.56-2.71-2.4.09-3.41,2.44-3.61,3.67-.1.6.31,1.17.92,1.27.04,0,.09.01.13.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m281.47,78.29s1.02-1.09,3.15-1.32c2.18-.23,4.09,1.06,4.11,1.07l1.26-1.82c-.1-.07-2.6-1.77-5.61-1.45-3.04.32-4.53,1.99-4.59,2.06l1.67,1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.84,91.82c.58.03,1.09-.41,1.15-1,0-.07.21-1.74,1.34-1.79,1.1-.06,1.39.74,1.46.98.16.58.75.95,1.34.79.59-.15.95-.73.81-1.32-.23-.96-1.3-2.77-3.7-2.67-2.45.09-3.34,2.52-3.46,3.78-.06.61.38,1.15.99,1.21.02,0,.04,0,.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m264.77,82.29s.71-1.32,2.7-2.09c2.04-.79,4.23-.04,4.25-.03l.75-2.09c-.12-.04-2.96-1.04-5.79.04-2.85,1.1-3.86,3.09-3.9,3.18l1.99.98Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m286.02,98.17c-3.91-.78-7.74-4.28-7.45-10.31.28-5.9,4.26-8.94,8.07-9.34h.01c.17-.01,4.09-.34,7.05,2.2,1.86,1.59,2.9,3.93,3.09,6.95.21,3.3-.94,6.23-3.25,8.24-1.6,1.4-3.67,2.25-5.64,2.37-.65.04-1.28,0-1.89-.12Zm.78-18.05c-4.34.45-6.46,4.25-6.63,7.82-.17,3.66,1.66,7.76,6.16,8.66,1.97.4,4.39-.35,6.16-1.89,1.36-1.19,2.93-3.36,2.7-6.93-.16-2.56-1.01-4.53-2.52-5.83-2.32-2-5.52-1.85-5.85-1.83h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m263.51,99.6c-3.91-.78-7.74-4.28-7.45-10.31.28-5.9,4.26-8.94,8.07-9.34h.01c.17-.02,4.1-.34,7.06,2.2,1.86,1.59,2.9,3.93,3.09,6.95.21,3.3-.94,6.23-3.25,8.24-1.6,1.4-3.67,2.25-5.64,2.37-.65.04-1.28,0-1.89-.12Zm.78-18.05c-4.34.45-6.46,4.25-6.63,7.82-.17,3.66,1.66,7.76,6.16,8.66,1.97.4,4.39-.35,6.16-1.89,1.36-1.19,2.93-3.36,2.7-6.93-.16-2.56-1.01-4.52-2.52-5.83-2.32-2-5.52-1.85-5.85-1.83h-.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 273.22,
    y: 87.64,
    width: 5.67,
    height: 1.6,
    transform: "translate(-5.05 17.69) rotate(-3.64)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m242.73,247.39l76.8,3.14s16.12,55.88-4.12,68.08c-.04.02-80.88-3.64-80.89-3.68-7.28-35.93,8.22-67.54,8.22-67.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m201.88,260.78c8.96-9.55,49.42-17.21,49.42-17.21l5.22,55.99s-42.36-1.93-62.46-2.84c-1.91-.09,1.3-29,7.81-35.94Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m278.32,281.81c-31.46-1.43-55.88-28.19-54.45-59.65,1.43-31.46,28.19-55.88,59.64-54.45,31.46,1.43,55.88,28.19,54.45,59.65-1.43,31.46-28.19,55.88-59.65,54.45Zm4.69-103.16c-25.42-1.16-47.05,18.58-48.2,44.01-1.16,25.42,18.58,47.05,44.01,48.2s47.05-18.58,48.2-44.01c1.16-25.42-18.58-47.05-44.01-48.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "HAND_L",
    "data-name": "HAND L"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m225.84,198.18c1.43-5.41,6.86-12.89,13.95-13.14,4.76-.17,8.89,3.51,8.47,7.66,0,0,2.98,1.17,2.52,4.22-1.37,9-5.17,7.15-5.17,7.15,0,0,.1.7-1.02,1.21-.88.4-1.93,0-1.93,0,0,0,1.39,1.92.64,3.53-.78,1.7-2.26,2.31-2.26,2.31,0,0,.19,1.27-1.84,2.23-2.23,1.05-5.34-1.58-6.45-2.35-.37-.26-.87,3.62-.97,6.68-6.15-1.39-9.29-6.85-5.95-19.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m241.19,201.59c-1.53-1.42-4.63-2.89-4.98-3.05-.68-.31-1.48-.02-1.8.65-.32.68-.02,1.48.65,1.8.84.39,3.25,1.62,4.28,2.58.95.88,2.22,2.53,2.23,2.54.25.33.63.51,1.01.53.31.01.62-.08.88-.28.59-.45.7-1.3.25-1.9-.06-.08-1.42-1.84-2.54-2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m239.58,207.44c-2.58-2.26-6.01-2.44-6.16-2.45-.74-.03-1.37.54-1.41,1.28s.54,1.38,1.28,1.42c.03,0,2.65.16,4.5,1.78.95.83,2.17,2.48,2.19,2.5.25.34.63.53,1.03.55.3.01.6-.07.86-.26.6-.44.73-1.29.28-1.89-.06-.08-1.41-1.9-2.58-2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m249.59,192.88c.1-.74-.42-1.42-1.17-1.52-.72-.1-1.42.42-1.52,1.17-.08.62-.39,2.47-.87,3.69-1.84-2.81-5.48-5.35-5.99-5.69-.62-.42-1.46-.26-1.88.35-.42.62-.26,1.46.35,1.88,2.08,1.42,5.52,4.37,5.85,6.23.49,2.71-.07,4.67-.08,4.69-.22.71.18,1.47.9,1.69.11.03.22.05.34.06.6.03,1.17-.35,1.35-.96.03-.09.64-2.2.26-5.17.45-.43,1.01-1.1,1.38-2.04.71-1.78,1.04-4.28,1.05-4.38Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "HAND_R",
    "data-name": "HAND R"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m341.12,203.34c-.93-5.52-5.66-13.46-12.7-14.35-4.73-.6-9.17,2.69-9.13,6.86,0,0-3.08.89-2.89,3.97.55,9.08,4.5,7.59,4.5,7.59,0,0-.16.69.9,1.29.84.47,1.92.18,1.92.18,0,0-1.55,1.79-.96,3.46.63,1.76,2.04,2.5,2.04,2.5,0,0-.31,1.25,1.63,2.39,2.13,1.25,5.46-1.09,6.63-1.75.4-.22.54,3.69.36,6.74,6.25-.82,9.87-5.98,7.7-18.88Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m328.98,196.78c.65-.36.89-1.19.52-1.84-.36-.66-1.19-.89-1.84-.52-.54.3-4.39,2.5-6.48,5.13-.44-1.51-.53-3.73-.53-3.75-.03-.75-.66-1.35-1.4-1.3-.75.03-1.33.66-1.3,1.4,0,.11.11,2.62.65,4.46.29.97.78,1.69,1.19,2.16-.64,2.92-.23,5.07-.21,5.17.13.62.66,1.04,1.26,1.07.11,0,.22,0,.33-.03.73-.15,1.2-.86,1.06-1.59,0-.02-.39-2.03.35-4.68.5-1.82,4.19-4.44,6.4-5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m324.72,209.8s1.43-1.54,2.45-2.33c1.11-.86,3.62-1.86,4.49-2.18.7-.25,1.07-1.03.82-1.73-.25-.7-1.02-1.06-1.73-.82-.36.13-3.58,1.31-5.23,2.58-1.21.93-2.72,2.57-2.79,2.64-.51.55-.47,1.4.08,1.91.24.23.55.35.86.36.39.02.77-.13,1.06-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m332.96,209.43c-.15,0-3.58-.14-6.36,1.88-1.26.92-2.77,2.61-2.83,2.68-.5.56-.45,1.41.11,1.91.24.21.54.33.84.34.39.02.79-.13,1.07-.45.01-.02,1.38-1.54,2.4-2.29,1.98-1.44,4.59-1.37,4.65-1.36.74.03,1.38-.54,1.41-1.29s-.54-1.38-1.29-1.41Z"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m247.75-11.04s-1.81,13.35,4.26,13.51c7.15.2,7.75-1.98,8.18-5.88.42-3.91-.51-7.65-.51-7.65,0,0-.38,3.46-2.67,3.59-4.1.24-7.74.79-8.3-.14-.55-.92-.96-3.44-.96-3.44Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublish);
export default __webpack_public_path__ + "static/media/Publish.46dd2e2ffb9cb9869a826ba3e907fc50.svg";
export { ForwardRef as ReactComponent };